import { ref, onMounted, computed } from "vue";

export default {
	name: "EspotContainer",
	props: {
		espotId: {
			type: String,
			required: true,
		},
	},
	setup(props: any) {
		const marketingHtml = ref("");

		onMounted(() => {
			const marketingContent = document.getElementById(props.espotId);
			if (marketingContent) {
				marketingHtml.value = marketingContent.innerHTML;
				marketingContent.remove();
			}
		});

		// Computed property per controllare se c'è contenuto valido
		const hasNonCommentContent = computed(() => {
			// Rimuove i commenti e controlla se rimane qualcosa
			const nonCommentContent = marketingHtml.value.replace(/<!--[\s\S]*?-->/g, "").trim();
			return nonCommentContent.length > 0;
		});

		return {
			marketingHtml,
			espotClass: props.espotId,
			hasNonCommentContent
		};
	},
};
